import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const LeaveFormSlice = createSlice({
  name: "LeaveFormReducer",
  initialState,
  reducers: {
    setLeaveData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setLeaveData, resetState } = LeaveFormSlice.actions;

export default LeaveFormSlice.reducer;
